
<div class="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-4">
  <div class="">
    <div class="dropdown">
      <button class="btn btn-filter w-100 my-auto text-start" id="dropdownMenuButton1" [attr.data-bs-toggle]="toggle"
        aria-expanded="false">
        <div class="d-flex justify-content-between">
          <div class="d-flex" style="width: 100%;">
            <i class="bi bi-funnel me-2 funnel-icon"></i>

            <input id="filter-input" type="text" class="filter-input" placeholder="Compañías"
              [(ngModel)]="selectedBranch" [typeahead]="companies" (typeaheadOnSelect)="onSelect($event)"
              typeaheadOptionField="name">
          </div>
          <div class="drop-button" *ngIf=" selectedBranch !== '' ">
            <i class="bi bi-x" (click)="cleanFilter()"></i>
          </div>
        </div>
      </button>

    </div>
  </div>
  <div class="d-flex flex-wrap mini-gap justify-content-center justify-content-lg-start overflow-auto">
    <button class="btn btn-sm py-2" [ngClass]="timeFilter == 'D' ? 'btn-secondary' : 'btn-outline-secondary'"
      (click)="changeTimeFilter('D')">
      Hoy
    </button>
    <button class="btn btn-sm py-2" [ngClass]="timeFilter == 'W' ? 'btn-secondary' : 'btn-outline-secondary'"
      (click)="changeTimeFilter('W')">
      Semana
    </button>
    <button class="btn btn-sm py-2" [ngClass]="timeFilter == 'M' ? 'btn-secondary' : 'btn-outline-secondary'"
      (click)="changeTimeFilter('M')">
      Mes
    </button>
    <button class="btn btn-sm text-nowrap py-2" [ngClass]="timeFilter == '3M' ? 'btn-secondary' : 'btn-outline-secondary'"
      (click)="changeTimeFilter('3M')" >
      Tres meses
    </button>
    <button class="btn btn-sm py-2" [ngClass]="
        timeFilter == 'ALL' ? 'btn-secondary' : 'btn-outline-secondary'
      " (click)="changeTimeFilter('ALL')">
      Acumulado
    </button>
  </div>
  <div class="">
    <div class="dropdown">
      <button class="btn btn-sm btn-success px-4 py-2 text-nowrap" id="actions" data-bs-toggle="dropdown" aria-expanded="false">
        Descargar <i class="bi bi-chevron-down"></i>
      </button>

      <ul class="dropdown-menu" aria-labelledby="actions">
        <li>
          <a class="dropdown-item" (click)="generateExcel()">Excel <i class="bi bi-file-earmark-excel"></i>
          </a>
        </li>
        <li>
          <a class="dropdown-item" (click)="toPdf()">PDF <i class="bi bi-file-earmark-pdf"></i></a>
        </li>
      </ul>
    </div>
  </div>
</div>
